import { render, staticRenderFns } from "./AccountCategory.vue?vue&type=template&id=e06f5b04&scoped=true&"
import script from "./AccountCategory.vue?vue&type=script&lang=js&"
export * from "./AccountCategory.vue?vue&type=script&lang=js&"
import style0 from "./AccountCategory.vue?vue&type=style&index=0&id=e06f5b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06f5b04",
  null
  
)

export default component.exports